import { useState } from 'react'
import Card from '@mui/joy/Card'
import FormControl from '@mui/joy/FormControl'
import FormLabel from '@mui/joy/FormLabel'
import Input from '@mui/joy/Input'
import Button from '@mui/joy/Button'
import RadioGroup from '@mui/joy/RadioGroup'
import Radio from '@mui/joy/Radio'
import Box from '@mui/joy/Box'
import { FilePickerButton } from './ui/FilePickerButton'
import { CLIP_LENGTH_CODES } from '../consts'

const ALLOWED_FILETYPES = 'video/*'

const ClipLengthRadio = ({ value, onChange }) => {
    return (
        <FormControl sx={{ display: 'flex' }}>
            <RadioGroup value={value} onChange={onChange}>
                <Box sx={{ display: 'flex', gap: 2, flexDirection: 'row' }}>
                    <Radio
                        value={CLIP_LENGTH_CODES.AUTO}
                        label="Auto"
                        variant="outlined"
                    />
                    <Radio
                        value={CLIP_LENGTH_CODES.LESS_THAN_THIRTY}
                        label="<30"
                        variant="outlined"
                    />
                    <Radio
                        value={CLIP_LENGTH_CODES.THIRTY_SIXTY}
                        label="30-60"
                        variant="outlined"
                    />
                    <Radio
                        value={CLIP_LENGTH_CODES.SIXTY_NINETY}
                        label="60-90"
                        variant="outlined"
                    />
                    <Radio
                        value={CLIP_LENGTH_CODES.NINETY_PLUS}
                        label="90+"
                        variant="outlined"
                    />
                </Box>
            </RadioGroup>
        </FormControl>
    )
}

const CaptionsRadio = ({ value, onChange }) => (
    <div>
        <FormLabel>Enable video captions</FormLabel>
        <FormControl sx={{ display: 'flex' }}>
            <RadioGroup value={value} onChange={onChange}>
                <Box sx={{ display: 'flex', gap: 2, flexDirection: 'row' }}>
                    <Radio value="yes" label="Yes" variant="outlined" />
                    <Radio value="no" label="No" variant="outlined" />
                </Box>
            </RadioGroup>
        </FormControl>
    </div>
)

const FillerWordsRadio = ({ value, onChange }) => (
    <div>
        <FormLabel>Remove long pauses and filler words</FormLabel>
        <FormControl sx={{ display: 'flex' }}>
            <RadioGroup value={value} onChange={onChange}>
                <Box sx={{ display: 'flex', gap: 2, flexDirection: 'row' }}>
                    <Radio value="yes" label="Yes" variant="outlined" />
                    <Radio value="no" label="No" variant="outlined" />
                </Box>
            </RadioGroup>
        </FormControl>
    </div>
)

export const VideoCampaignForm = ({ onSubmit }) => {
    const [title, setTitle] = useState(null)
    const [file, setFile] = useState(null)
    const [targetClipLength, setTargetClipLength] = useState(
        CLIP_LENGTH_CODES.AUTO
    )
    const [enableCaptions, setEnableCaptions] = useState('yes')
    const [removeFillerWords, setRemoveFillerWords] = useState('no')

    const replaceImage = (e) => {
        setFile(e.target.files[0])
    }

    const handleChange = (e) => {
        setTargetClipLength(e.currentTarget.value)
    }

    const handleCaptions = (e) => {
        setEnableCaptions(e.target.value)
    }

    const handleFillerWordsChange = (e) => {
        setRemoveFillerWords(e.target.value)
    }

    return (
        <Card
            sx={{
                width: 450,
                maxWidth: 900,
            }}
            variant="outlined"
            color="neutral"
        >
            <FormControl sx={{ display: 'flex', gap: 2 }}>
                <div>
                    <FormLabel>Campaign Title</FormLabel>
                    <Input
                        placeholder="My Campaign"
                        required
                        onChange={(e) => setTitle(e.target.value)}
                    />
                </div>
            </FormControl>
            <div>
                <FormLabel>Video File</FormLabel>
                <div>{file && file.name}</div>
                <FilePickerButton
                    onFileChange={replaceImage}
                    accept={ALLOWED_FILETYPES}
                />
            </div>
            <div>
                <FormLabel>Clip Length (in seconds)</FormLabel>
                <ClipLengthRadio
                    value={targetClipLength}
                    onChange={handleChange}
                />
            </div>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <CaptionsRadio
                    value={enableCaptions}
                    onChange={handleCaptions}
                />
                <FillerWordsRadio
                    value={removeFillerWords}
                    onChange={handleFillerWordsChange}
                />
            </Box>
            <Button
                variant="solid"
                color="primary"
                type="submit"
                disabled={!file || !title}
                sx={{ minWidth: 100, alignSelf: 'end' }}
                onClick={() =>
                    onSubmit({
                        title: title,
                        file: file,
                        targetClipLength: targetClipLength,
                        enableCaptions: enableCaptions === 'yes',
                        removeSilence: removeFillerWords === 'yes',
                    })
                }
            >
                Go
            </Button>
        </Card>
    )
}
